<template>
  <a-layout class="create-application-box">
    <a-card class="create-application" :bordered=false>
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
        <span class="page-status " :class="{'page-status-yellow':params.status==='审批中','page-status-green':params.status==='审批通过'||params.status==='付款成功','page-status-red':params.status==='审批拒绝'||params.status==='付款失败','page-status-gray':params.status==='已撤回'}">{{params.status}}</span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && loadedLayout ">
        <common-form v-if="layout.type==='commonForm'" :ref="'commonForm'" :layout="layout" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange"></common-form>
        <upload v-if="layout.type==='upload'" :layout="layout" :default-file-none="defaultFillNone" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <adjust-table v-if="layout.type==='budgetAdjustTable'" :layout="layout" :columns="columns" :edit-columns="editColumns" :param="params[layout.field]" :can-edit="canEdit" @update-data="updateTable"></adjust-table>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'必填信息填写后，流程将自动显示'" v-if="loadedInfo && loadedLayout"></approval-flow>
      <div style="text-align:center" v-if="!loadedInfo || !loadedLayout">
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-row class="footer">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="20">
          <a-button @click="visibleComment = true" style="width:120px;" v-if="loadedInfo && loadedLayout">评论</a-button>
        </a-col>
      </a-row>
    </a-card>
    <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
  </a-layout>
</template>

<script>
import moment from "moment";
import UUID from "uuidjs";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { data } from "../../data/mockData.js";
import { layoutConfigDetail, mockParamsDetail } from "../../utils/mockData.js";
import AdjustTable from "../../components/AdjustTable.vue";
import CommonForm from "../../components/CommonForm.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import Upload from "../../components/Upload.vue";
import FormModal from "../../components/FormModal.vue";
import { getApprovalFlow } from "../../services/CommonService.js";
import {
  UpdateData,
  COLUMNS,
  getBudgetChangeLayout,
  getBudgetChangeDetailParams,
  getBudgetDetailApprovalFlow,
  getBudgetChangeDetailInfo
} from "../../services/BudgetChangeService.js";
let columns = _.cloneDeep(COLUMNS);
columns.splice(columns.length - 1, 1);

export default {
  components: {
    AdjustTable,
    CommonForm,
    ApprovalFlow,
    Upload,
    FormModal
  },
  props: {},
  data() {
    return {
      columns: columns,
      dataSource: [],
      editColumns: columns.slice(2, columns.length - 1).map(item => ({
        dataIndex: item.dataIndex, //表格列key， month1,month2...
        month: item.title, //表格列名，2020-01,2020-02...
        monthNum: moment(item.title).month() //对应月份，0,1,2...
      })),
      breadcrumb: [
        {
          label: "我已审批详情",
          path: ""
        }
      ],
      defaultFillNone: false,
      canEdit: false,
      pageLayout: {},
      params: {},
      loadedLayout: true,
      loadedInfo: true,
      approvalFlowInfo: [],
      requestParams: {},
      cancelSource: null,
      visibleComment: false
    };
  },
  created() {
    this.requestParams = _.cloneDeep(this.params);
    this.fetchParams().then(() => {
      this.fetchLayout();
    });
  },

  methods: {
    fetchLayout() {
      this.loadedLayout = false;
      getBudgetChangeLayout({ id: this.$route.query.id, type: "detail" }).then(
        res => {
          if (res.status === "success") {
            this.pageLayout = res.data;
            this.pageLayout.contents.forEach(item => {
              if (item.type === "budgetAdjustTable") {
                item.initFinished = false;
                this.updateData(this.params[item.field]); // 预算调整表格数据格式化
                this.requestParams = _.cloneDeep(this.params);
                this.fetchApprovalFlow();
                item.initFinished = true;
              }
            });
            this.loadedLayout = true;
          } else {
            this.$Message.error(res.message);
          }
        }
      );
    },
    fetchParams() {
      this.loadedInfo = false;
      return getBudgetChangeDetailParams({
        id: this.$route.query.id,
        type: "detail"
      }).then(res => {
        if (res.status === "success") {
          this.params = res.data;
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    updateData(data) {
      UpdateData(data);
    },
    updateTable(e) {
      this.params[e.field] = e.data;
      UpdateData(this.params[e.field]);
    },
    back() {
      this.$router.replace({
        name: "waitApprovalList"
      });
    },
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      LayoutConfig.setAllParams(this.params);
      this.requestParams = _.cloneDeep(this.params);
    },
    cancelQuest() {
      if (typeof this.cancelSource === "function") {
        this.cancelSource("终止请求"); //取消请求
      }
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      this.cancelQuest();
      getBudgetDetailApprovalFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
</style>
